import CardList from './component'

export default CardList